import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const getFilenameFromDisposition = (disposition, fallback) => {
  const filenameMatch = (disposition || '').match(/filename[^;=\n]*=["']?([^"';\n]+)/);
  return filenameMatch ? filenameMatch[1] : fallback;
};

const handlePdfResponse = async (res, fallbackFilename, errorPrefix) => {
  if (!res.ok) {
    const errorText = await res.text();
    const error = new Error(errorText || `${errorPrefix}: ${res.status}`);
    error.status = res.status;
    throw error;
  }

  const blob = await res.blob();
  const filename = getFilenameFromDisposition(
    res.headers.get('Content-Disposition'),
    fallbackFilename
  );

  return { blob, filename };
};

const todayStamp = () => new Date().toISOString().slice(0, 10).replace(/-/g, '');

const superbillApi = {
  getOptions: async (clientReferenceId) => {
    const res = await fetch(`${config.api.url}/clients/${clientReferenceId}/superbill/options`, {
      headers: getAuthHeaders(),
    });
    return handleResponse(res);
  },

  previewSuperbill: async (clientReferenceId, payload) => {
    const res = await fetch(`${config.api.url}/clients/${clientReferenceId}/superbills/preview`, {
      method: 'POST',
      headers: getAuthHeaders({ Accept: 'application/pdf' }),
      body: JSON.stringify(payload),
    });

    return handlePdfResponse(
      res,
      `superbill-preview-${clientReferenceId}-${todayStamp()}.pdf`,
      'Superbill preview failed'
    );
  },

  generateSuperbill: async (clientReferenceId, payload) => {
    const res = await fetch(`${config.api.url}/clients/${clientReferenceId}/superbills`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });
    return handleResponse(res);
  },

  listClientSuperbills: async (clientReferenceId) => {
    const res = await fetch(`${config.api.url}/clients/${clientReferenceId}/superbills`, {
      headers: getAuthHeaders(),
    });
    return handleResponse(res);
  },

  downloadSuperbill: async (superbillReferenceId) => {
    const res = await fetch(`${config.api.url}/superbills/${superbillReferenceId}/download`, {
      headers: getAuthHeaders({ Accept: 'application/pdf' }),
    });

    return handlePdfResponse(
      res,
      `superbill-${superbillReferenceId}-${todayStamp()}.pdf`,
      'Superbill download failed'
    );
  },
};

export default superbillApi;
